import React, { Component } from 'react';
import { Text, Image } from './styles';


class Final extends Component {
  render() {
    return (
      <Text>
        <br />
        <p>
          <Image src="https://cdn-icons-png.flaticon.com/512/148/148767.png" />
        </p>

        <p>
          <h3>Questionários respondidos com sucesso!</h3>
        </p>
        <p>Agradecemos a sua colaboração.</p>
        <p>
          O preenchimento deste questionário será fundamental na elaboração de
          ações de saúde para a sua empresa.
        </p>
        <p>Cuide sempre da sua saúde!</p>
      </Text>
    );
  }
}

export default Final;
